module.exports = __webpack_public_path__ + "static/media/p9.d9eaf81d.png";